// src/pages/national-coverage/components/CoverageHero.jsx
import React from "react";

const ORANGE = "#F27E33";
const NAVY   = "#1D2946";

export default function CoverageHero() {
  return (
    <section className="pt-10 pb-6">
      <h1
        className="font-orbitron font-bold text-white text-4xl md:text-6xl text-center"
        style={{ letterSpacing: "0.02em" }}
      >
        Cobertura a Nivel Nacional
      </h1>

      <div className="flex justify-center mt-5 mb-6">
        <span
          className="h-1 rounded-full"
          style={{
            width: 200,
            background: `linear-gradient(90deg, ${ORANGE}, ${NAVY})`,
            boxShadow: `0 0 18px ${ORANGE}33`,
          }}
        />
      </div>

      <p className="font-body text-white/90 text-center max-w-3xl mx-auto">
        Operamos desde la <span className="font-semibold">Oficina Principal en Bogotá</span> con
        equipos locales y logística ágil para atender proyectos en las principales
        ciudades del país. Transparencia, cumplimiento y soporte 24/7.
      </p>
    </section>
  );
}
